import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobsTable from './jobs-table.jsx';

if (document.getElementById(
  'react-component-g4-logistics-portal-subcontracted-jobs'
)) {
  ReactDOM.render(<JobsTable
    url= "/api/v1/portal/jobs/subcontracted"
    infiniteScroll={true}
    message_if_none = 'No jobs that are subcontracted.'
  />,
document.getElementById(
  'react-component-g4-logistics-portal-subcontracted-jobs'
));
}
